import React from 'react';
import PropTypes from 'prop-types';
import { Flex } from '@chakra-ui/react';
import {
  FacebookShareButton,
  PinterestShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from 'react-share';

import {
  BsFacebook,
  BsTelegram,
  BsTwitter,
  BsPinterest,
  BsWhatsapp,
} from 'react-icons/bs';
import styled from 'styled-components';

const SocialIcon = styled.div`
  background: #083874;
  padding: 12px;
  border-radius: 8px;
  height: 48px;
`;

export default function BlogShare({ image, title }) {
  const shareUrl = typeof window !== 'undefined' && window?.location?.href;
  return (
    <Flex mb={[6, null, 10]} gap={4}>
      <FacebookShareButton url={shareUrl} quote={title}>
        <SocialIcon>
          <BsFacebook size={24} color="white" />
        </SocialIcon>
      </FacebookShareButton>
      <TwitterShareButton url={shareUrl} title={title}>
        <SocialIcon>
          <BsTwitter size={24} color="white" />
        </SocialIcon>
      </TwitterShareButton>
      {image && (
        <PinterestShareButton url={shareUrl} media={image}>
          <SocialIcon>
            <BsPinterest size={24} color="white" />
          </SocialIcon>
        </PinterestShareButton>
      )}
      <WhatsappShareButton url={shareUrl} title={title}>
        <SocialIcon>
          <BsWhatsapp size={24} color="white" />
        </SocialIcon>
      </WhatsappShareButton>
      <TelegramShareButton url={shareUrl} title={title}>
        <SocialIcon>
          <BsTelegram size={24} color="white" />
        </SocialIcon>
      </TelegramShareButton>
    </Flex>
  );
}

BlogShare.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};
